import './style.css';

/**
 * Shows login restriction popup when user reaches search or PDP view limit
 * @param {string} type - 'pdp' or 'search'
 * @param {Function} onLogin - Callback when login button is clicked
 * @param {Function} onClose - Callback when popup is closed
 */
export const showLoginRestrictionPopup = (type = 'pdp', onLogin, onClose) => {
  // Check if popup already exists
  const existingPopup = document.querySelector('.login-popup-overlay');
  if (existingPopup) {
    return; // Don't show duplicate popup
  }

  const popup = document.createElement('div');
  popup.className = 'login-popup-overlay';
  
  const message = type === 'pdp' 
    ? "You've viewed 4 product details. Please login to explore more products."
    : "You've performed 4 searches. Please login to explore more products.";
  
  popup.innerHTML = `
    <div class="login-popup-container">
      <h3 class="login-popup-title">
        🔒 Login Required
      </h3>
      <p class="login-popup-message">
        ${message}
      </p>
      <div class="login-popup-buttons">
        <button id="login-btn-popup" class="login-popup-btn login-popup-btn-primary">
          Login
        </button>
        <button id="close-btn-popup" class="login-popup-btn login-popup-btn-secondary">
          Close
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(popup);

  const loginBtn = popup.querySelector('#login-btn-popup');
  const closeBtn = popup.querySelector('#close-btn-popup');
  const container = popup.querySelector('.login-popup-container');

  const removePopup = () => {
    if (popup && popup.parentNode) {
      document.body.removeChild(popup);
    }
  };

  loginBtn.onclick = (e) => {
    e.stopPropagation();
    removePopup();
    if (onLogin) {
      onLogin();
    }
  };

  closeBtn.onclick = (e) => {
    e.stopPropagation();
    removePopup();
    if (onClose) {
      onClose();
    }
  };

  // Prevent clicks inside container from closing popup
  container.onclick = (e) => {
    e.stopPropagation();
  };

  // Close on background click
  popup.onclick = (e) => {
    if (e.target === popup) {
      removePopup();
      if (onClose) {
        onClose();
      }
    }
  };
};

